import { Component, ViewChild, ElementRef } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent {
  items: Observable<any>;
  msg = '';
  userName = localStorage.getItem('userName');
  @ViewChild('scroller') private feedContainer: ElementRef;

  constructor(public db: AngularFireDatabase) {

  }

  ngOnInit() {
    this.items = this.db.list('messages').valueChanges();
    // this.db.list('items').valueChanges().subscribe(resp => {
    //   console.log(resp);
    // });
  }

  scrollToBottom(): void {
    this.feedContainer.nativeElement.scrollTop = this.feedContainer.nativeElement.scrollHeight;
  }

  onSubmit() {
    this.scrollToBottom();
    console.log('msg is',this.msg);
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    var hours = dateObj.getUTCHours();
    var mins = dateObj.getUTCMinutes();

    let newdate = day + "/" + month + "/" + year+'('+hours+':'+mins+')';

    this.db.list('messages').push({ user: this.userName, message: this.msg, date: newdate });
    this.msg = '';
  }
}
